export default __webpack_public_path__ + "static/media/support.2ded1244.png";